import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faFilePdf, faFileSignature, faFilter, faMailReply, faSave, faTasks } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';


//Components
import TextField from '../../../components/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';

//API
import tipoDeFiscalizacao_api from "../../../api/tipoDeFIscalizacao_api";
import fiscalizacaoInfracaoDividaAtiva_api from '../../../api/fiscalizacaoInfracaoDividaAtiva_api';

//Helpers
import { objCampo, validarCampos, isDateOverflow } from '../../../helpers/ValidadorDeCampos';
import { criarOnChangeMultiSelect } from '../../../helpers/onChangeMultiSelect';
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

//Contants
import { actionsTable } from '../../../constants/MaterialTable';
import ModeloImpressao from './components/ModeloImpressao';

function initialStateDividaAtiva() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);

    return {
        tipoBusca: 'Data de Infração',
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
        tipoFiscalizacao_Ids: [],
        numeroInfracao: "",
        logradouro: '',
        numero: '',
        bairro: '',
        nome: '',
        situacaoDividaAtiva: "Todos"
    }
}

function initialStateAcaoDividaAtiva() {
    return {
        fiscalizacaoInfracao_Id: "",
        dataInscricao: "",
        numeroProcessoSEI: "",
        dataBaixa: "",
        valorPago: "",
        observacao: ""
    }
}

//Confirmações de UI da baixa manual — não são persistidas
function initialStateConfirmacoesBaixa() {
    return {
        cadim: false,
        dividaAtiva: false
    }
}

export default function DividaAtiva() {
    const { setLoading } = useAuth();

    //State para consultar Gereciamento de Arrecadação
    const [consultaDividaAtiva, setConsultaDividaAtiva] = useState(initialStateDividaAtiva());

    //State para pegar o valor do modal
    const [acaoDividaAtiva, setAcaoDividaAtiva] = useState(initialStateAcaoDividaAtiva());

    //State para pegar o valor do modal
    const [rowData, setRowData] = useState(null);

    //State para pegar lista dos tipos de fiscalizacao
    const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

    //State para cards
    const [listaDividaAtivas, setListaDividaAtivas] = useState([]);

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Estado de controle dos campos de erro do modal
    const [errorsModal, setErrorsModal] = useState({});

    //Estado que pega os dados passados via navegação
    const location = useLocation();

    //Estado de navegação
    const navigate = useNavigate();

    //State para visibilidade do modal
    const [openModal, setOpenModal] = useState(false);

    //Estado das confirmações obrigatórias da baixa manual (CADIM e Dívida Ativa)
    const [confirmacoesBaixa, setConfirmacoesBaixa] = useState(initialStateConfirmacoesBaixa());

    //State para alterar o state do modal
    const toggleModal = () => {
        setOpenModal(!openModal);
        setErrorsModal({});
        setAcaoDividaAtiva(initialStateAcaoDividaAtiva());
        setConfirmacoesBaixa(initialStateConfirmacoesBaixa());
        setRowData(null);
    };

    const [rowModeloImpressao, setRowModeloImpressao] = useState(null);

    //pegando a etapa selecionada no 
    const { filtro } = location.state ? location.state : {};

    const loadTipoDeFiscalizacao = () => {
        setLoading(true);
        tipoDeFiscalizacao_api.getList()
            .then(response => {
                response.data.map(value => {
                    value.value = value.id;
                    value.label = value.identificacao;
                    return value;
                })
                setListTipoDeFiscalizacao(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadTipoDeFiscalizacao();
        if (filtro) {
            setConsultaDividaAtiva({ ...filtro });
            handleConsultaDividaAtiva(filtro)
        }
    }, []);

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { objectValue: "numeroInfracao", value: "NÚMERO INFRAÇÃO", col: "12" },
        { objectValue: "nomeInfrator", value: "NOME INFRATOR", col: "12" },
        { objectValue: "infracao_Identificacao", value: "IDENTIFICAÇÃO DA INFRAÇÃO", col: "12" },
        { objectValue: "tipoFiscalizacao", value: "TIPO DE FISCALIZAÇÃO", col: "12" },
        { objectValue: "valorMulta", value: "VALOR DA MULTA", col: "12" },
        { objectValue: "numeroPrimeiraGuia", value: " NÚMERO DA PRIMEIRA GUIA", col: "6" },
        { objectValue: "vencimentoPrimeiraGuia", value: "VENCIMENTO PRIMEIRA GUIA", col: "6" },
        { objectValue: "numeroUltimaGuia", value: " NÚMERO DA ÚLTIMA GUIA", col: "6" },
        { objectValue: "vencimentoUltimaGuia", value: "VENCIMENTO ÚLTIMA GUIA", col: "6" },
        { objectValue: "valorJuros", value: "VALOR JUROS ÚLTIMA GUIA", col: "6" },
        { objectValue: "situacaoDividaAtiva", value: "SITUAÇÃO", col: "12" }
    ];

    //Estado de controle dos campos obrigatorios 
    const [campos] = useState([
        objCampo({ name: "tipoBusca", required: true }),
        objCampo({ name: "tipoFiscalizacao_Ids", required: true }),
        objCampo({ name: "situacaoDividaAtiva", required: true }),
    ]);

    //Estado de controle dos campos obrigatorios 
    const [camposModal, setCamposModal] = useState([]);

    const datatipoBusca = [
        { value: "Data de Infração", label: "Data de Infração" },
        { value: "Data do Boleto", label: "Data do Boleto" },
        { value: "Vencimento do Boleto", label: "Vencimento do Boleto" },
    ];

    const dataSituacaoDividaAtiva = [
        { value: "Todos", label: "Todos" },
        { value: "Não Inscrito", label: "Não Inscrito" },
        { value: "Inscrito", label: "Inscrito" },
        { value: "Baixa", label: "Baixa" },
    ]

    //Função para pegar o id da infração
    const visualizarFiscalizacao = (rowData) => {
        navigate("/admin/ficha-infracao", {
            state: {
                infracao_id: rowData.fiscalizacaoInfracao_Id,
                filtro: consultaDividaAtiva,
                originPath: "/admin/inscricaoDividaAtiva"
            }
        })
    }

    const handleConsultaStatusBoleto = (rowData) => {
        setLoading(true);
        fiscalizacaoInfracaoDividaAtiva_api.postConsultarStatusBoleto(rowData.fiscalizacaoInfracao_Id)
            .then(response => {
                if (response.data)
                    showMessage("Sucesso", "Pagamento localizado. O status do boleto foi atualizado para Baixado e a infração foi retirada da Dívida Ativa.", "success", () => handleConsultaDividaAtiva());
                else
                    showMessage("Atenção", "Não consta pagamento para os boletos desta infração.", "warning", null);
            })
            .catch(err => {
                var hasResponseProdam = err?.message?.toLowerCase()?.includes("resposta prodam")
                showMessage(hasResponseProdam ? "Atenção" : "Error", err?.message ?? "Error na operação.", hasResponseProdam ? "info" : "error", null)
            })
            .finally(() => setLoading(false));
    }

    const consultaStatusBoletoFunction = (rowData, actionStyle) => {
        if (rowData.situacaoDividaAtiva === "Baixa")
            return null;

        return actionsTable.consultaBoleto(() => handleConsultaStatusBoleto(rowData), "Consultar Status do Boleto");
    }

    const visibilidadeBotoesAcoes = (rowData, actionStyle) => {
        if (rowData.situacaoDividaAtiva == "Não Inscrito")
            return actionsTable.editar(() => {
                setRowData(rowData)
                setCamposModal([
                    objCampo({ name: "dataInscricao", required: true }),
                    objCampo({ name: "numeroProcessoSEI", required: true }),
                ]);
                setOpenModal(true);
            });
        if (rowData.situacaoDividaAtiva == "Inscrito")
            return actionsTable.editar(() => {
                setRowData(rowData);
                setCamposModal([
                    objCampo({ name: "dataBaixa", required: true }),
                    objCampo({ name: "valorPago", required: true })
                ]);
                setOpenModal(true);
            });
        else
            return null;
    }


    //Variavel que guarda as ações da tabela
    const actions = [
        actionsTable.visualizar(visualizarFiscalizacao),
        visibilidadeBotoesAcoes,
        consultaStatusBoletoFunction,
        actionsTable.imprimir((rowData) => { setRowModeloImpressao(rowData) }),
    ];

    const onChangeDividaAtiva = (value, e) => {
        const _consultaDividaAtiva = {
            ...consultaDividaAtiva,
            [e.name]: value ? value.value.toString() : null,
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_consultaDividaAtiva, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setConsultaDividaAtiva(_consultaDividaAtiva);
    }

    const onChangeMultiSelectDividaAtiva = criarOnChangeMultiSelect({
        state: consultaDividaAtiva,
        setState: setConsultaDividaAtiva,
        campos,
        errors,
        setErrors
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setConsultaDividaAtiva({
            ...consultaDividaAtiva,
            [name]: value
        })
    }

    const onChangeAcaoModalDividaAtiva = (e) => {
        const { name, value } = e.target;
        const _acaoDividaAtiva = {
            ...acaoDividaAtiva,
            [name]: value
        };

        const _campos = camposModal.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_acaoDividaAtiva, _campos);

        const _errors = { ...errorsModal };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrorsModal({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setAcaoDividaAtiva(_acaoDividaAtiva);
    }

    const handleSubmitDividaAtiva = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(acaoDividaAtiva, camposModal);
        setErrorsModal(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _acaoDividaAtiva = { ...acaoDividaAtiva }
        _acaoDividaAtiva.fiscalizacaoInfracao_Id = rowData.fiscalizacaoInfracao_Id;
        _acaoDividaAtiva.valorPago = _acaoDividaAtiva.valorPago
            ? parseFloat(_acaoDividaAtiva.valorPago.toString().replace(",", "."))
            : null;


        if (rowData.situacaoDividaAtiva == "Inscrito") {
            setLoading(true);
            fiscalizacaoInfracaoDividaAtiva_api.postBaixaDividaAtiva(_acaoDividaAtiva)
                .then(response => {
                    showMessage("Sucesso", "Sucesso na Operação.", "success", () => {
                        toggleModal();
                        handleConsultaDividaAtiva();
                    })
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        } else if (rowData.situacaoDividaAtiva == "Não Inscrito") {
            setLoading(true);
            fiscalizacaoInfracaoDividaAtiva_api.postInscreverDividaAtiva(_acaoDividaAtiva)
                .then(response => {
                    showMessage("Sucesso", "Sucesso na Operação.", "success", () => {
                        toggleModal();
                        handleConsultaDividaAtiva();
                    })
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    const handleConsultaDividaAtiva = async (filtro = null) => {
        if (!filtro) {
            const _errors = validarCampos(consultaDividaAtiva, campos);
            setErrors(_errors[0]);
            if (_errors[1].length > 0)
                return true;

            //Data Inicial/Final são opcionais quando Nome do Infrator ou Número da Infração forem informados
            const possuiFiltroAlternativo = !!(consultaDividaAtiva.nome?.trim() || consultaDividaAtiva.numeroInfracao?.trim());

            if (!possuiFiltroAlternativo && (!consultaDividaAtiva.dataInicial || !consultaDividaAtiva.dataFinal)) {
                showMessage("Aviso", "Informe o período de datas ou ao menos um dos filtros: Nome do Infrator ou Número da Infração.", "warning", null);
                return true;
            }

            if (consultaDividaAtiva.dataInicial && consultaDividaAtiva.dataFinal &&
                isDateOverflow(consultaDividaAtiva.dataInicial, consultaDividaAtiva.dataFinal, 12, 'months')) {
                showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null);
                return true;
            }
        }

        const _consultaDividaAtiva = filtro ? filtro : consultaDividaAtiva;
        setLoading(true);
        try {
            const { data } = await fiscalizacaoInfracaoDividaAtiva_api.getList(_consultaDividaAtiva);
            setListaDividaAtivas(data);
        }
        catch (err) {
            showMessage("Error", err?.message ?? "Erro na operação.", "error", null);
        }
        finally {
            setLoading(false);
        }
    };


    return (
        <>
            <h4 className='text-secondary m-0'>Dívida Ativa</h4>
            {!!rowModeloImpressao && <ModeloImpressao SelecionarModeloImpressao={rowModeloImpressao} setSelecionarModeloImpressao={setRowModeloImpressao} />}
            {openModal &&
                <ModalCustomized
                    size={'md'}
                    fullscreen={"lg"}
                    toggle={toggleModal}
                    widthPadrao={false}
                    isOpen={openModal}
                    btnClose={toggleModal}
                    title={"Situação Divida Ativa"}
                >
                    <Row>
                        {rowData && rowData.situacaoDividaAtiva == "Não Inscrito" &&
                            <>
                                <Col md={12} lg={12}>
                                    <TextField
                                        type={"date"}
                                        name={"dataInscricao"}
                                        label={"* Data Inscrição"}
                                        onChange={onChangeAcaoModalDividaAtiva}
                                        value={acaoDividaAtiva.dataInscricao}
                                        invalid={errorsModal.dataInscricao}
                                    />
                                </Col>
                                <Col md={12} lg={12}>
                                    <TextField
                                        type={"text"}
                                        name={"numeroProcessoSEI"}
                                        label={"* Número Processo SEI"}
                                        onChange={onChangeAcaoModalDividaAtiva}
                                        value={acaoDividaAtiva.numeroProcessoSEI}
                                        invalid={errorsModal.numeroProcessoSEI}
                                    />
                                </Col>
                            </>
                        }
                        {rowData && rowData.situacaoDividaAtiva == "Inscrito" &&
                            <>
                                <Col md={12} lg={12}>
                                    <TextField
                                        type={"date"}
                                        name={"dataBaixa"}
                                        label={"* Data do Pagamento"}
                                        onChange={onChangeAcaoModalDividaAtiva}
                                        value={acaoDividaAtiva.dataBaixa}
                                        invalid={errorsModal.dataBaixa}
                                    />
                                </Col>
                                <Col md={12} lg={12}>
                                    <TextField
                                        type={"text"}
                                        name={"valorPago"}
                                        label={"* Valor Pago"}
                                        mask={mascaras.floatMask}
                                        onChange={onChangeAcaoModalDividaAtiva}
                                        value={acaoDividaAtiva.valorPago}
                                        invalid={errorsModal.valorPago}
                                    />
                                </Col>
                                <Col md={12} lg={12}>
                                    <TextField
                                        type={"textarea"}
                                        name={"observacao"}
                                        label={"Observação"}
                                        onChange={onChangeAcaoModalDividaAtiva}
                                        value={acaoDividaAtiva.observacao}
                                    />
                                </Col>
                                <Col md={12} lg={12} className='mt-2'>
                                    <div className='d-flex align-items-center gap-2'>
                                        <Input
                                            type="checkbox"
                                            id="confirmacaoCadim"
                                            checked={confirmacoesBaixa.cadim}
                                            onChange={(e) => setConfirmacoesBaixa({ ...confirmacoesBaixa, cadim: e.target.checked })}
                                        />
                                        <label htmlFor="confirmacaoCadim" className='m-0'>CADIM</label>
                                    </div>
                                    <div className='d-flex align-items-center gap-2'>
                                        <Input
                                            type="checkbox"
                                            id="confirmacaoDividaAtiva"
                                            checked={confirmacoesBaixa.dividaAtiva}
                                            onChange={(e) => setConfirmacoesBaixa({ ...confirmacoesBaixa, dividaAtiva: e.target.checked })}
                                        />
                                        <label htmlFor="confirmacaoDividaAtiva" className='m-0'>Dívida Ativa</label>
                                    </div>
                                </Col>
                            </>
                        }
                    </Row>
                    <Row className='d-flex justify-content-center align-items-center'>
                        <Col md={12} lg={4}>
                            <Button
                                color='success'
                                className='text-white fw-bold w-100 mt-2'
                                onClick={handleSubmitDividaAtiva}
                                disabled={rowData?.situacaoDividaAtiva == "Inscrito" && !(confirmacoesBaixa.cadim && confirmacoesBaixa.dividaAtiva)}
                            >
                                <FontAwesomeIcon icon={faSave} />  Salvar
                            </Button>
                        </Col>
                    </Row>
                </ModalCustomized>
            }

            <Row className='mt-3'>
                <Col md={12} lg={3}>
                    <TextField
                        type={"select"}
                        name={"tipoBusca"}
                        label={"* Tipo de Busca"}
                        searchable
                        options={datatipoBusca}
                        onChange={onChangeDividaAtiva}
                        value={
                            datatipoBusca.filter(value => value.value == consultaDividaAtiva.tipoBusca)
                                .map(v => { return { value: v.value, label: v.value } })
                        }
                        invalid={!!errors.tipoBusca}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"select"}
                        name={"situacaoDividaAtiva"}
                        label={"* Situação Divida Ativa"}
                        searchable
                        options={dataSituacaoDividaAtiva}
                        onChange={onChangeDividaAtiva}
                        value={
                            dataSituacaoDividaAtiva.filter(value => value.value == consultaDividaAtiva.situacaoDividaAtiva)
                                .map(v => { return { value: v.value, label: v.value } })
                        }
                        invalid={!!errors.situacaoDividaAtiva}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"date"}
                        name={"dataInicial"}
                        label={"Data Inicial"}
                        onChange={onChange}
                        value={consultaDividaAtiva.dataInicial}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"date"}
                        name={"dataFinal"}
                        label={"Data Final"}
                        onChange={onChange}
                        value={consultaDividaAtiva.dataFinal}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"select"}
                        name={"tipoFiscalizacao_Ids"}
                        label={"* Tipo de Fiscalização"}
                        multiple
                        options={listTipoDeFiscalizacao}
                        onChange={onChangeMultiSelectDividaAtiva}
                        value={listTipoDeFiscalizacao.filter(value => (consultaDividaAtiva.tipoFiscalizacao_Ids ?? []).includes(value.value))}
                        invalid={!!errors.tipoFiscalizacao_Ids}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"text"}
                        name={"numeroInfracao"}
                        label={"Número da infração"}
                        onChange={onChange}
                        value={consultaDividaAtiva.numeroInfracao}
                    />
                </Col>
                <Col md={12} lg={5}>
                    <TextField
                        type={"text"}
                        name={"nome"}
                        label={"Nome"}
                        onChange={onChange}
                        value={consultaDividaAtiva.nome}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"text"}
                        name={"bairro"}
                        label={"Bairro"}
                        onChange={onChange}
                        value={consultaDividaAtiva.bairro}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"text"}
                        name={"logradouro"}
                        label={"Logradouro"}
                        onChange={onChange}
                        value={consultaDividaAtiva.logradouro}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        type={"text"}
                        name={"numero"}
                        label={"Numero"}
                        mask={mascaras.numeroMask}
                        onChange={onChange}
                        value={consultaDividaAtiva.numero}
                    />
                </Col>
            </Row>

            <div className='d-flex justify-content-center gap-3'>
                <div>
                    <Button
                        color='primary'
                        className='text-white fw-bold w-100'
                        onClick={() => handleConsultaDividaAtiva()}
                    >
                        <FontAwesomeIcon icon={faFilter} /> Filtrar
                    </Button>
                </div>
            </div>

            {listaDividaAtivas.length > 0 &&
                <Row className='mt-2'>
                    <Col lg={3} className='mb-2'>
                    </Col>
                    <Col lg={12}>
                        <TabelaListagem
                            actions={actions}
                            title={`Dívida Ativa`}
                            options={{ print: false, search: true, pagination: true }}
                            headers={headers}
                            items={listaDividaAtivas}
                        />
                    </Col>
                </Row>
            }
        </>
    )
}
